import { PapiDeviation } from '@wix/da-papi-types';
import truncate from 'lodash/truncate';
import isPlainObject from 'lodash/isPlainObject';
import { cloneObject } from '../../components/utils/browser';

// List of boolean keys from PapiDeviation
const bools: string[] = [
  'isJournal',
  'isVideo',
  'isGif',
  'isPurchasable',
  'isAdoptable',
  'isFavouritable',
  'isTextEditable',
  'isBackgroundEditable',
  'isShareable',
  'isCommentable',
  'isFavourited',
  'isDeleted',
  'isMature',
  'isNsfg',
  'isAllowedForSafeAccess',
  'isDownloadable',
  'isAntisocial',
  'isBlocked',
  'isPublished',
  'isScheduled',
  'isPinned',
  'isDailyDeviation',
  'hasPrivateComments',
  'hasCommentedOn',
  'hasNft',
  'isDreamsofart',
  'isAiUseDisallowed',
  'isAiGenerated',
  'canUpdateAiClaim',
  'hyped',
  'hasNewContent',
];

// The optional fields we can safely drop
const drop: string[] = [
  'extended',
  'stats',
  'isTextEditable',
  'legacyTextEditUrl',
  'dailyDeviation',
  'motionBook',
  'print',
  'pcp',
  'blockReason',
  'blockReasons',
  'groupDestination',
  'background',
];

// Nested deviations
const nested: string[] = ['coverImage', 'primaryTier'];

export function toLightweightDeviation(deviation: PapiDeviation): PapiDeviation {
  const lightweight: Partial<PapiDeviation> = {};

  const keys = Object.keys(deviation);
  for (const key of keys) {
    // Text content, chop down excerpt and remove fulltext
    if (key === 'textContent' && deviation['textContent']) {
      lightweight[key] = {
        excerpt: truncate(deviation[key]?.excerpt, {
          length: 50,
          separator: /,? +/,
          omission: '',
        }),
        html: {
          type: deviation[key]?.html.type ?? 'tiptap',
          features: deviation[key]?.html?.features ?? '',
        },
      };
      continue;
    }

    // Drop keys we dont need
    if (drop.includes(key)) {
      continue;
    }

    // Nested PapiDeviations
    if (nested.includes(key) && deviation[key]) {
      lightweight[key] = toLightweightDeviation(deviation[key]);
      continue;
    }

    // Copy plain objects
    if (isPlainObject(deviation[key])) {
      lightweight[key] = cloneObject(deviation[key]);
      continue;
    }

    // boolean optim, drop any falsey values
    if (bools.includes(key) && deviation[key] === false) {
      continue;
    }

    // scalar copy it over
    lightweight[key] = deviation[key];
  }

  return lightweight as PapiDeviation;
}
